export default __webpack_public_path__ + "static/media/cancelled-status.4a461590.svg";